/**
 * Dr. Herança application module (single-tenant entry).
 */

import { TenantModule, TenantConfig } from 'src/core/types/appConfig';
import { drherancaConfig } from './config';
import drherancaRoutes from './routes';
import { drherancaApi } from './api';

export const drherancaTenant: TenantModule = {
    config: drherancaConfig,
    routes: drherancaRoutes,
    api: drherancaApi,
};

/** Compatibility aliases for store, App, and core (formerly multi-tenant barrel). */
export const activeTenant: TenantModule = drherancaTenant;
export const activeTenantConfig: TenantConfig = drherancaConfig;
export const activeTenantRoutes = drherancaRoutes;
export const activeTenantApi = drherancaApi;

export type { TenantConfig, TenantModule, TenantContext } from 'src/core/types/appConfig';

export { drherancaConfig } from './config';
export { default as drherancaRoutes } from './routes';
export * from './api';
export * from './types';
export * from './schemas';
export * from './services';
